function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
module.exports = function (app, mod, chat_group) {
  var html = '';
  var formatUser = function formatUser(publickey) {
    var usericon = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var fourthElement = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '<div></div>';
    var imgsrc = app.keychain.returnIdenticon(publickey);
    var name = app.keychain.returnIdentifierByPublicKey(publickey, true);
    if (name == publickey) {
      name = 'Anonymous User';
    }
    return "<div class=\"saito-contact\" >\n\t\t\t\t\t\t\t\t<div class=\"saito-user saito-add-user-menu\" data-id=\"".concat(publickey, "\">\n\t                \t\t\t\t<div class=\"saito-identicon-box\"><img class=\"saito-identicon\" src=\"").concat(imgsrc, "\">").concat(usericon, "</div>\n\t                  \t\t\t\t<div class=\"saito-address\" data-id=\"").concat(publickey, "\" data-disable=\"true\">").concat(name, "</div>\n\t                \t\t\t\t<div class=\"saito-userline\">").concat(publickey, "</div>\n\t                \t\t\t\t").concat(fourthElement, "\n\t                \t\t\t</div>\n\t            \t\t\t  </div>");
  };
  if (chat_group !== null && chat_group !== void 0 && chat_group.member_ids) {
    html += "<div class=\"saito-modal-content hide-scrollbar\">";
    for (var publickey in chat_group.member_ids) {
      var icon = '';
      var fourth = '';
      if (chat_group.member_ids[publickey] == 'admin') {
        icon = "<i class=\"saito-overlaid-icon fa-solid fa-key\"></i>";
      }
      if (chat_group.member_ids[mod.publicKey] == 'admin') {
        if (chat_group.member_ids[publickey] !== 'admin') {
          fourth = "<div class=\"remove_user saito-user-fourth-elem-large\" data-id=\"".concat(publickey, "\"><i class=\"fa-solid fa-user-minus\"></i></div>");
        } else {
          fourth = '<div></div>';
        }
      }

      //Filter for deactivated users...
      if (chat_group.member_ids[publickey] == 1 || icon) {
        html += formatUser(publickey, icon, fourth);
      }
    }
    html += '</div>';
  } else if (chat_group.name === mod.communityGroupName) {
    var active_users = [];
    for (var i = chat_group.txs.length - 1; i >= 0; i--) {
      var key = chat_group.txs[i].from;
      if (Array.isArray(key)) {
        var _iterator = _createForOfIteratorHelper(key),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var k = _step.value;
            if (!active_users.includes(k)) {
              active_users.push(k);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      } else {
        if (!active_users.includes(key)) {
          active_users.push(key);
        }
      }
    }
    for (var _i = 0, _active_users = active_users; _i < _active_users.length; _i++) {
      var _publickey = _active_users[_i];
      html += formatUser(_publickey);
    }
    html = "<div class=\"saito-modal-content hide-scrollbar\">".concat(html, "</div>");
  }
  return html;
};